module.exports = __webpack_public_path__ + "img/China Head Office.451fd600.png";